import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }

    static getDerivedStateFromError(error) {
        return { error };
    }

    componentDidCatch(error, info) {
        console.error('[ErrorBoundary]', error, info);
    }

    render() {
        if (this.state.error) {
            return (
                <div style={{ padding: 24, fontFamily: 'monospace' }}>
                    <h3 style={{ color: '#c0392b' }}>Something went wrong</h3>
                    <pre style={{ color: '#c0392b', whiteSpace: 'pre-wrap', fontSize: 12 }}>
                        {this.state.error.toString()}
                    </pre>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
